import { createContext, useContext } from 'react';
export const SlateKitContext = createContext({
    kit: null,
    context: null,
});
export const useSlateKitContext = () => {
    const context = useContext(SlateKitContext);
    return context;
};
//# sourceMappingURL=slate-kit-context.hook.js.map